import { app } from '@/core/firebase'

const getAddress = async (postalCode) => {
  const getAddressFunc = app.functions().httpsCallable('getAddressFunction')
  const response = await getAddressFunc({ postalCode })
  if (response.data.results.length === 1) {
    const components = response.data.results[0].address_components
    return {
      prefecture: components[components.findIndex(c => c.types.includes("administrative_area_level_1"))].long_name,
      municipality: components[components.findIndex(c => c.types.includes('locality'))].long_name
    }
  } else {
    throw new Error('Cannot specifiy the address.')
  }
}

export { getAddress }